import axios from "axios";
const API_ROOT = process.env.REACT_APP_API_END_POINT

const agent = async (url, body) => {
  const config = {
    headers: {
       Authorization: `Bearer ${window?.token}`,
    },
  };
  const response = await axios.post(`${API_ROOT}${url}`,body,config);
 return response
};

export const userDetails = async(body,token)=>{
    const config = {
    headers: {
       Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(`${API_ROOT}/api/GetUserDetailByUPN`,body,config);
 return response
}

const requests = {
  post: (url, body) => agent(url, body, "POST"),
};


const DcoiApis = {
  unblockRequest_Process:(body)=>requests.post(`/api/UnblockRequest_Process`,body),
  getUnblockRequest:(body)=>requests.post(`/api/GetUnblockRequests`,body),
  saveUnblockRequest:(body)=>requests.post(`/api/SaveUnblockRequest`,body),
  postGetFormLabelByUserName: (body) => requests.post(`/api/GetFormLabelByUserName`, body),
  GetSubmissionsByUsername: (body) => requests.post(`/api/GetSubmissionsByUsername`, body),
  V_GetSubmissionsByUsername: (body) => requests.post(`/api/VCOI/V_GetSubmissionsByUsername`, body),
  GetDefaulFormLabelByUserName: (body) => requests.post(`/api/GetDefaulFormLabelByUserName`, body),
  V_GetDefaulFormLabelByUserName: (body) => requests.post(`/api/VCOI/V_GetDefaulFormLabelByUserName`, body),
  GetUserDetailByUPN:(body)=>requests.post(`/api/GetUserDetailByUPN`,body),
  V_GetUserDetailByUPN:(body)=>requests.post(`/api/VCOI/V_GetUserDetailByUPN`,body),
  GetAllPolicies:(body)=>requests.post(`/api/GetAllPolicies`,body),
  V_GetAllPolicies:(body)=>requests.post(`/api/VCOI/V_GetAllPolicies`,body),
  GetAllEmailTemplates:(body)=>requests.post(`/api/GetAllEmailTemplates`,body),
  V_GetAllEmailTemplates:(body)=>requests.post(`/api/VCOI/V_GetAllEmailTemplates`,body),
  GetAllEntities:(body)=>requests.post(`/api/GetAllEntities`,body),
  V_GetAllEntities:(body)=>requests.post(`/api/VCOI/V_GetAllEntities`,body),
  GetAllAgencies:(body)=>requests.post(`/api/GetAllAgencies`,body),
  V_GetAllAgencies:(body)=>requests.post(`/api/VCOI/V_GetAllAgencies`,body),
  GetAllCountries:(body)=>requests.post(`/api/GetAllCountries`,body),
  V_GetAllCountries:(body)=>requests.post(`/api/VCOI/V_GetAllCountries`,body),
  GetAllPolicyByHFMCode:(body)=>requests.post(`/api/GetAllPolicyByHFMCode`,body),
  GetAllFormLabels:(body)=>requests.post(`/api/GetAllFormLabels`,body),
  V_GetAllFormLabels:(body)=>requests.post(`/api/VCOI/V_GetAllFormLabels`,body),
  GetAllEntitiesForUserAdmin:(body)=>requests.post(`/api/GetAllEntitiesForUserAdmin`,body),
  V_GetAllEntitiesForUserAdmin:(body)=>requests.post(`/api/VCOI/V_GetAllEntitiesForUserAdmin`,body),
  getsumission:(body)=>requests.post(`/api/GetSubmissionPdfDoc`,body),
  V_Getsumission:(body)=>requests.post(`/api/VCOI/V_GetSubmissionPdfDoc`,body),
  GetUsersAndGroups:(body)=>requests.post(`/api/GetUsersAndGroups`,body),
  V_GetUsersAndGroups:(body)=>requests.post(`/api/VCOI/V_GetUsersAndGroups`,body),
  SubmitForm:(body)=>requests.post(`/api/SubmitForm`,body),
  SubmitV_Form:(body)=>requests.post(`/api/VCOI/V_SubmitForm`,body),
  GetAllEntitiesWithActiveCycle:(body)=>requests.post(`/api/GetAllEntitiesWithActiveCycle `,body),
  SubmitCycle:(body)=>requests.post(`/api/SubmitCycle `,body),
  DeleteUserFromGroup:(body)=>requests.post(`/api/DeleteUserFromGroup `,body),
  AddUserInGroup:(body)=>requests.post(`/api/AddUserInGroup `,body),
  V_AddUserInGroup:(body)=>requests.post(`/api/VCOI/V_AddUserInGroup `,body),
  SavePolicy:(body)=>requests.post(`/api/SavePolicy `,body),
  V_SavePolicy:(body)=>requests.post(`/api/VCOI/V_SavePolicy `,body),
  GetAdminGroups:(body)=>requests.post(`/api/GetAdminGroups `,body),
  V_GetAdminGroups:(body)=>requests.post(`/api/VCOI/V_GetAdminGroups `,body),
  UpdateEmailTemplate:(body)=>requests.post(`/api/UpdateEmailTemplate `,body) ,
  GetSolutionHubs:(body)=>requests.post(`/api/GetSolutionHubs `,body) ,
  V_GetSolutionHubs:(body)=>requests.post(`/api/VCOI/V_GetSolutionHubs `,body) ,
  AddGroup:(body)=>requests.post(`/api/AddGroup `,body),
  V_AddGroup:(body)=>requests.post(`/api/VCOI/V_AddGroup `,body),
  GetAdminPermission:(body)=>requests.post(`/api/GetAdminPermissions`,body),
  V_GetAdminPermission:(body)=>requests.post(`/api/VCOI/V_GetAdminPermissions`,body),
  SaveAdminPermission:(body)=>requests.post(`/api/SaveAdminPermission`,body),
  V_SaveAdminPermission:(body)=>requests.post(`/api/VCOI/V_SaveAdminPermission`,body),
  DeleteAdminPermission:(body)=>requests.post(`/api/DeleteAdminPermission`,body),
  V_DeleteAdminPermission:(body)=>requests.post(`/api/VCOI/V_DeleteAdminPermission`,body),
  DeletePolicy:(body)=>requests.post(`/api/DeletePolicy`,body),
  V_DeletePolicy:(body)=>requests.post(`/api/VCOI/V_DeletePolicy`,body),
  DeleteEmailTemplate:(body)=>requests.post(`/api/DeleteEmailTemplate`,body),
  V_DeleteEmailTemplate:(body)=>requests.post(`/api/VCOI/V_DeleteEmailTemplate`,body),
  ResetStatus:(body)=>requests.post(`/api/ResetStatus`,body),
  SaveEmailTemplate:(body)=>requests.post(`/api/SaveEmailTemplate`,body),  
  V_SaveEmailTemplate:(body)=>requests.post(`/api/VCOI/V_SaveEmailTemplate`,body),    
  SaveAgency:(body)=>requests.post(`/api/SaveAgency`,body),
  V_SaveAgency:(body)=>requests.post(`/api/VCOI/V_SaveAgency`,body),
  SaveCountry :(body)=>requests.post(`/api/SaveCountry`,body),
  V_SaveCountry :(body)=>requests.post(`/api/VCOI/V_SaveCountry`,body),
  DeleteEntity:(body)=>requests.post(`/api/DeleteEntity`,body),
  SaveEntity:(body)=>requests.post(`/api/SaveEntity`,body),
  DeleteFormLabels:(body)=>requests.post(`/api/DeleteFormLabels`,body),
  SaveFormLabels:(body)=>requests.post(`/api/SaveFormLabels`,body),
  GetPolicyandEmailSetting:(body)=>requests.post(`/api/GetPolicyandEmailSetting`,body),
  V_GetPolicyandEmailSetting:(body)=>requests.post(`/api/VCOI/V_GetPolicyandEmailSetting`,body),
  SavePolicyandEmailSetting:(body)=>requests.post(`/api/SavePolicyandEmailSetting`,body),
  DeletePolicyandEmailSetting:(body)=>requests.post(`/api/DeletePolicyandEmailSetting`,body),
  RespondentDashboard:(body)=>requests.post(`/api/RespondentDashboard`,body),
  V_RespondentDashboard:(body)=>requests.post(`/api/VCOI/V_RespondentDashboard`,body),
  RespondentDocuments:(body)=>requests.post(`/api/RespondentDocuments`,body),
  V_RespondentDocuments:(body)=>requests.post(`/api/VCOI/V_RespondentDocuments`,body),
  UnblockUsers:(body)=>requests.post(`/api/UnblockUsers`,body),
  GetSubmissionPdfDocZip:(body)=>requests.post(`/api/GetSubmissionPdfDocZip`,body),
  V_GetSubmissionPdfDocZip:(body)=>requests.post(`/api/VCOI/V_GetSubmissionPdfDocZip`,body),
  RemindUser:(body)=>requests.post(`/api/SendReminder`,body),
  V_SendReminder:(body)=>requests.post(`/api/VCOI/V_SendReminder`,body),
  SendInvitationAndReminder:(body)=>requests.post(`/api/SendInvitationAndReminder`,body),
  V_SendInvitationAndReminder:(body)=>requests.post(`/api/VCOI/V_SendInvitationAndReminder`,body),
  downloadExcelReport:(body)=>requests.post(`/api/downloadExcelReport`,body),
  V_downloadExcelReport:(body)=>requests.post(`/api/VCOI/V_downloadExcelReport`,body),
  UserFormData:(body)=>requests.post(`/api/GetSubmissionAndAFADetails`,body),
  GetAllCycleForEntity:(body)=>requests.post(`/api/GetAllCycleForEntity`,body),
  DeleteCycleForEntity:(body)=>requests.post(`/api/DeleteCycleForEntity`,body),
  GetAdminGroupsByUPN:(body)=>requests.post(`/api/GetAdminGroupsByUPN`,body),
  V_GetAdminGroupsByUPN:(body)=>requests.post(`/api/VCOI/V_GetAdminGroupsByUPN`,body),
  GetAdminGroupsByUPNNotMappedWithEntity:(body)=>requests.post(`/api/GetAdminGroupsByUPNNotMappedWithEntity`,body),
  V_GetAdminGroupsByUPNNotMappedWithEntity:(body)=>requests.post(`/api/VCOI/V_GetAdminGroupsByUPNNotMappedWithEntity`,body),
  GetPolicyByHFMCodeAndLanguageId:(body)=>requests.post(`/api/GetPolicyByHFMCodeAndLanguageId`,body),
  V_GetPolicyByHFMCodeAndLanguageId:(body)=>requests.post(`/api/VCOI/V_GetPolicyByHFMCodeAndLanguageId`,body),
  V_AllRespondents:(body)=>requests.post(`/api/VCOI/V_AllRespondents`,body),
  DownloadArchivalExcelReport:(body)=>requests.post(`/api/downloadArchivalExcelReport`,body),
};

export default {
    DcoiApis,
};
